import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  Tabs,
  Tab,
  IconButton,
  Typography,
  Box,
  Slide,
  Link
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SwipeableViews from "react-swipeable-views";

// import ContactForm from "./ContactForm";

import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default React.memo(function Content({
  contentScreen,
  setContentScreen
}) {
  const { breakpoints } = useTheme();
  const isLarge = useMediaQuery(breakpoints.up("md"));
  return (
    <Dialog
      fullScreen={!isLarge}
      maxWidth="md"
      open={contentScreen !== -1}
      onClose={() => setContentScreen(-1)}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogTitle>
        More info
        <IconButton
          onClick={() => setContentScreen(-1)}
          color="inherit"
          style={{ float: "right" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Tabs
        value={contentScreen === -1 ? 0 : contentScreen}
        onChange={(e, newValue) => setContentScreen(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
      >
        <Tab label="About" />
        <Tab label="Usage" />
        <Tab label="Download data" />
        <Tab label="Contact us" />
        {/* <Tab label="Leave feedback" /> */}
      </Tabs>
      <SwipeableViews
        index={contentScreen === -1 ? 0 : contentScreen}
        onChangeIndex={i => setContentScreen(i)}
        animateHeight
      >
        <About />
        <Usage />
        <DownloadData />
        <Box p={4}>
          <Typography variant="body1" gutterBottom>
            Any questions, comments or suggestions relating to this site please
            contact us below.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            component="a"
            href="mailto:gisfeedback@melbourne.vic.gov.au?subject=Development%20Activity%20Model%20Feedback%2FQuestion"
          >
            Email us
          </Button>
        </Box>
        {/* <ContactForm setContentScreen={setContentScreen} /> */}
        {/* <FeedbackForm /> */}
      </SwipeableViews>
    </Dialog>
  );
});

function About() {
  return (
    <Box p={{ xs: 2, md: 4 }} maxHeight={{ md: 500 }} overflow="scroll">
      <Typography variant="body1" gutterBottom>
        The site content includes information about development activity located
        within the City of Melbourne municipal area. Developments may have one
        of three statuses with a different colour for each status. Applied
        (blue), Approved (green) and Under Construction (yellow).
      </Typography>

      <Typography variant="body1" gutterBottom>
        Site content is derived from a range of sources at various times and as
        such the content may not be free from errors, omissions or defects.
        Inconsistencies may occur in some data sets. The City of Melbourne uses
        its best endeavours to ensure that the information is reliable.
      </Typography>

      <Typography variant="body1" gutterBottom>
        The building models are representational only and are not intended for
        analytical or comparative purposes. The site content does not contain
        natural features such as the terrain. The building models are simplified
        extrusions of the indicative floor plate for the podium (if relevant)
        and tower. The extrusion is an approximation of the height of the
        building and does not show the architectural features of the buildings.
      </Typography>

      <Typography variant="body1" gutterBottom>
        The information in the table below is provided to help users understand
        the currency and reliability of the site content which often involves
        complex processes to derive the information. The aim is to provide users
        with some facts about the source of the content and when it was
        collected. Users can then make an informed decision as to whether the
        site content is appropriate for their particular purpose and information
        needs.
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Content</TableCell>
            <TableCell>Source</TableCell>
            <TableCell>Currency</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell colSpan={3}>
              <strong>Model Information</strong>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Applied (Blue)</TableCell>
            <TableCell>
              City of Melbourne planning and permits information system, City of
              Melbourne Development Activity Monitor
            </TableCell>
            <TableCell>Maximum of two months old</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Approved (Green)</TableCell>
            <TableCell>
              City of Melbourne planning and permits information system, City of
              Melbourne Development Activity Monitor
            </TableCell>
            <TableCell>Maximum of two months old</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Under Ionstruction (Yellow)</TableCell>
            <TableCell>
              City of Melbourne planning and permits information system, City of
              Melbourne Development Activity Monitor
            </TableCell>
            <TableCell>Maximum of two months old</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Current (Grey)</TableCell>
            <TableCell>
              Building footprints extruded by height of podium (where
              applicable) and tower
            </TableCell>
            <TableCell>May 2018</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={3}>
              <strong>Filtering Information</strong>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Residential</TableCell>
            <TableCell>
              Developments with more than 10 residential dwellings or 10 student
              accommodation units
            </TableCell>
            <TableCell>Maximum of two months old</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Commercial</TableCell>
            <TableCell>
              Developments with more than 500 square metres of office, retail or
              recreation floor space. Developments with a hostel bed, childcare
              place or more than 10 serviced apartments.
            </TableCell>
            <TableCell>Maximum of two months old</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={3}>
              <strong>Map</strong>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Base map</TableCell>
            <TableCell>
              Open street map data served through the Mapbox platform
            </TableCell>
            <TableCell>Monthly (by third parties)</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
}

function trackOutboundClick(e) {
  window.gtag("event", "click", {
    event_category: "outbound",
    event_label: e.target.parentElement.href
  });
}

function Usage() {
  return (
    <Box p={{ xs: 2, md: 4 }}>
      <Typography variant="body1" gutterBottom>
        All 3D Models are simplified interpretations of complex built forms and
        should not be used for planning purposes.
      </Typography>
      <Typography variant="body1" gutterBottom>
        The City of Melbourne asserts copyright for City of Melbourne data and
        other material provided on this website.
      </Typography>
      <Typography variant="body1" gutterBottom>
        Except for the base map provided by open street maps and any other
        content supplied by third parties on this website, the City of Melbourne
        logo, and any material protected by a trade mark, the City of Melbourne
        has applied the Creative Commons Attribution 3.0 Australia Licence to
        support and encourage the dissemination and exchange of information. The
        City of Melbourne asserts the right to be attributed as author of its
        original material in the following manner:
      </Typography>
      <Typography variant="body1" gutterBottom>
        © City of Melbourne {new Date().getFullYear()}
      </Typography>
      <Typography variant="body1" gutterBottom>
        As far as practicable, material for which the copyright is owned by a
        third party will be clearly labelled. The City of Melbourne has made all
        reasonable efforts to ensure that this material has been reproduced on
        this website with the full consent of the copyright owners.
      </Typography>
      <Typography variant="body1" gutterBottom>
        <Link
          href="https://www.melbourne.vic.gov.au/Pages/home.aspx"
          rel="noopener"
          onClick={trackOutboundClick}
          title="Creative Commons License"
        >
          <img
            src="https://i.creativecommons.org/l/by/3.0/au/88x31.png"
            width={88}
            height={31}
            alt="Creative Commons License"
          />
        </Link>
      </Typography>
      <Typography variant="body1" gutterBottom>
        City of Melbourne Maps by{" "}
        <Link
          href="https://www.melbourne.vic.gov.au/Pages/home.aspx"
          rel="noopener"
          onClick={trackOutboundClick}
          title="City of Melbourne"
        >
          City of Melbourne
        </Link>{" "}
        is licensed under a{" "}
        <Link
          href="https://creativecommons.org/licenses/by/3.0/au/"
          rel="noopener"
          onClick={trackOutboundClick}
          title="Creative Commons License"
        >
          Creative Commons Attribution 3.0 Australia License
        </Link>
        .
      </Typography>
    </Box>
  );
}

function DownloadData() {
  return (
    <Box p={{ xs: 2, md: 4 }}>
      <Typography variant="body1" gutterBottom>
        Data for the Development Activity Model can be found on the City of
        Melbourne Open Data platform
      </Typography>

      <Button
        component="a"
        target="_blank"
        href="https://data.melbourne.vic.gov.au/explore/dataset/development-activity-model-footprints/export/"
        onClick={trackOutboundClick}
        title="Download Development Footprints"
        variant="contained"
        color="primary"
        style={{ marginBottom: 16 }}
      >
        Download Development Footprints
        <CloudDownloadIcon style={{ marginLeft: 8 }} />
      </Button>
      <br />
      <Button
        component="a"
        target="_blank"
        href="https://data.melbourne.vic.gov.au/explore/dataset/2018-building-footprints/export/"
        onClick={trackOutboundClick}
        title="Download all footprints"
        style={{ marginBottom: 16 }}
        variant="contained"
        color="primary"
      >
        Download all existing footprints
        <CloudDownloadIcon style={{ marginLeft: 8 }} />
      </Button>
      <br />
      <Button
        component="a"
        target="_blank"
        title="download tabular data"
        href="https://data.melbourne.vic.gov.au/explore/dataset/development-activity-monitor/export/"
        onClick={trackOutboundClick}
        variant="contained"
        color="primary"
        style={{ marginBottom: 16 }}
      >
        Download Tabular data
        <CloudDownloadIcon style={{ marginLeft: 8 }} />
      </Button>
    </Box>
  );
}
